import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  message: string;
  confirmAction: CallableFunction;
  @ViewChild('confirmModal') confirmModal;
  modalRef: NgbModalRef;

  constructor(
    private modalService: NgbModal,) { }

  ngOnInit(): void {
  }

  open(message: string, confirmAction = null) {
    this.message = message;
    this.confirmAction = confirmAction;
    this.modalRef = this.modalService.open(this.confirmModal, {
      keyboard: false,
      size: 'lg',
      centered: true
    });

  }
  confirmRequest(Res: boolean) {
    if (Res) {
      this.confirmAction();
    } else {
      this.close();
    }
  }

  close() {
    this.modalRef.close();
  }

}
